<div
  class="gd-form-select-multiple-v2">

  <!-- Input data -->
  <mat-form-field
    *ngIf="!viewOnly; else viewOnlyTemplate"
    appearance="outline">

    <!-- Place holder -->
    <mat-label
      *ngIf="!neverFloatLabel">
      {{ placeholder | translate }}
    </mat-label>

    <!-- Left - Icon buttons -->
    <ng-container
      *ngIf="tooltipButton?.tooltip"
      matPrefix>
      <popper-content
        #popperContent>
        <div
          [innerHtml]="tooltipButton.tooltip | safeHtml">
        </div>
      </popper-content>
      <mat-icon
        tabindex="-1"
        [popper]="popperContent"
        popperTrigger="hover"
        popperApplyClass="gd-form-input-v2-tooltip"
        popperPreventOverflow="true"
        popperPositionFixed="true"
        popperAppendTo="body"
        (click)="$event.stopPropagation()">{{tooltipButton.icon}}</mat-icon>
    </ng-container>

    <!-- Select -->
    <mat-select
      [(ngModel)]="value"
      (closed)="onTouchItem()"
      [errorStateMatcher]="errMatcher"
      [disabled]="disabled"
      [required]="required"
      [placeholder]="neverFloatLabel ? (placeholder | translate) : undefined"
      multiple="true"
      panelClass="gd-form-select-multiple-v2-panel"
      (click)="vScrollToFirstSelectedOption()"
      (opened)="vScrollToFirstSelectedOption()"
      (ngModelChange)="changedSinceLastChangedAndClosed = true"
      (openedChange)="changedAndClosedTrigger($event)">

      <!-- Selected value -->
      <mat-select-trigger
        *ngIf="value">

        <!-- multiple select ? -->
        <div
          fxLayout="row wrap"
          class="gd-form-select-multiple-v2-panel-inner">
          <ng-container
            *ngFor="let selectedValue of value; let selectedIndex = index">

            <!-- separator -->
            <ng-container
              *ngIf="selectedIndex > 0">, </ng-container>

            <!-- Icon -->
            <mat-icon
              *ngIf="allOptionsMap[selectedValue]?.icon">{{allOptionsMap[selectedValue].icon}}</mat-icon>

            <!-- Image -->
            <img
              *ngIf="allOptionsMap[selectedValue]?.iconUrl"
              [src]="allOptionsMap[selectedValue]?.iconUrl"/>

            <!-- Label -->
            {{allOptionsMap[selectedValue]?.label}}

          </ng-container>
        </div>

      </mat-select-trigger>

      <!-- Search filter -->
      <mat-option>
        <ngx-mat-select-search
          ngModel
          [placeholderLabel]="'LNG_COMMON_LABEL_SEARCH' | translate"
          [noEntriesFoundLabel]="null"
          [clearSearchInput]="true"
          [disableScrollToActiveOnOptionsChanged]="true"
          [preventHomeEndKeyPropagation]="true"
          [showToggleAllCheckbox]="true"
          [toggleAllCheckboxChecked]="toggleAllCheckboxChecked"
          (ngModelChange)="filterOptions($event); toggleAllCheckboxChecked = false;"
          (toggleAll)="toggleAll($event)">
        </ngx-mat-select-search>
      </mat-option>

      <!-- vscroll -->
      <cdk-virtual-scroll-viewport
        #cdkVirtualScrollViewport
        [itemSize]="40"
        [minBufferPx]="240"
        [maxBufferPx]="480"
        style="height: 20rem; overflow-x: hidden;">

        <!-- Options -->
        <mat-option
          *cdkVirtualFor="let option of filteredOptions; templateCacheSize: 0"
          [value]="option.value"
          [disabled]="!allowDisabledToBeSelected && option.disabled && !selectedValues[option.value]">
          <div
            [matTooltip]="optionTooltipKey ? option.data[optionTooltipKey] : undefined">

            <!-- Icon -->
            <mat-icon
              *ngIf="option.icon">{{option.icon}}</mat-icon>

            <!-- Image -->
            <img
              *ngIf="option.iconUrl"
              [src]="option.iconUrl"/>

            <!-- Label -->
            {{option.label}}

          </div>
        </mat-option>

      </cdk-virtual-scroll-viewport>

      <!-- Selected option(s) hack to handle not visible in virtual scroll options -->
      <ng-container
        *ngIf="value">

        <!-- Options -->
        <ng-container
          *ngFor="let selectedValue of value">
          <mat-option
            *ngIf="allOptionsMap[selectedValue]"
            style="height: 0; display: none;"
            [value]="selectedValue">

            <!-- Icon -->
            <mat-icon
              *ngIf="allOptionsMap[selectedValue].icon">{{allOptionsMap[selectedValue].icon}}</mat-icon>

            <!-- Image -->
            <img
              *ngIf="allOptionsMap[selectedValue].iconUrl"
              [src]="allOptionsMap[selectedValue].iconUrl"/>

            <!-- Label -->
            {{allOptionsMap[selectedValue].label}}

          </mat-option>
        </ng-container>

      </ng-container>

    </mat-select>

    <!-- Errors -->
    <mat-error
      *ngIf="control?.invalid && control?.touched">
      {{ getErrorMessages() }}
    </mat-error>

  </mat-form-field>

  <!-- View only -->
  <ng-template
    #viewOnlyTemplate>
    <div
      fxLayout="row" fxLayoutGap="1.6rem"
      class="gd-form-select-multiple-v2-viewonly">
      <!-- Label -->
      <div
        *ngIf="placeholder"
        class="gd-form-select-multiple-v2-viewonly-label">
        {{ placeholder | translate }}:
      </div>

      <!-- Value -->
      <div
        class="gd-form-select-multiple-v2-viewonly-value">
        <!-- Has value -->
        <ng-container
          *ngIf="value?.length > 0; else noValue">
          <ng-container
            *ngFor="let selectedValue of value; let selectedIndex = index">

            <!-- separator -->
            <ng-container
              *ngIf="selectedIndex > 0">, </ng-container>

            <!-- Icon -->
            <mat-icon
              *ngIf="allOptionsMap[selectedValue]?.icon">{{allOptionsMap[selectedValue].icon}}</mat-icon>

            <!-- Image -->
            <img
              *ngIf="allOptionsMap[selectedValue]?.iconUrl"
              [src]="allOptionsMap[selectedValue]?.iconUrl"/>

            <!-- Label -->
            {{allOptionsMap[selectedValue]?.label}}

          </ng-container>
        </ng-container>

        <!-- Doesn't have value -->
        <ng-template
          #noValue>
          {{noValueLabel}}
        </ng-template>
      </div>
    </div>
  </ng-template>
</div>
